import { action } from 'typesafe-actions';
import {
  WebhookActionTypes,
  WebhookSubscriptionAddPayload,
  WebhookSubscriptionUpdatePayload,
  WebhookSubscriptionResponse,
  Params
} from 'types';

export const getWebhookSubscriptionsStart = (payload: Params) =>
  action(WebhookActionTypes.GET_WEB_HOOK_SUBSCRIPTIONS_START, payload);

export const getWebhookSubscriptionsSuccess = (payload: any) =>
  action(WebhookActionTypes.GET_WEB_HOOK_SUBSCRIPTIONS_SUCCESS, payload);

export const getWebhookSubscriptionsFailure = (payload: string) =>
  action(WebhookActionTypes.GET_WEB_HOOK_SUBSCRIPTIONS_FAILURE, payload);

export const addWebhookSubscriptionStart = (
  payload: WebhookSubscriptionAddPayload
) => action(WebhookActionTypes.ADD_WEB_HOOK_SUBSCRIPTION_START, payload);

export const addWebhookSubscriptionSuccess = (
  payload: WebhookSubscriptionResponse
) => action(WebhookActionTypes.ADD_WEB_HOOK_SUBSCRIPTION_SUCCESS, payload);

export const addWebhookSubscriptionFailure = (payload: string) =>
  action(WebhookActionTypes.ADD_WEB_HOOK_SUBSCRIPTION_FAILURE, payload);

export const updateWebhookSubscriptionStart = (
  payload: WebhookSubscriptionUpdatePayload
) => action(WebhookActionTypes.UPDATE_WEB_HOOK_SUBSCRIPTION_START, payload);

export const updateWebhookSubscriptionSuccess = (
  payload: WebhookSubscriptionResponse
) => action(WebhookActionTypes.UPDATE_WEB_HOOK_SUBSCRIPTION_SUCCESS, payload);

export const updateWebhookSubscriptionFailure = (payload: string) =>
  action(WebhookActionTypes.UPDATE_WEB_HOOK_SUBSCRIPTION_FAILURE, payload);

export const deleteWebhookSubscriptionStart = (payload: number) =>
  action(WebhookActionTypes.DELETE_WEB_HOOK_SUBSCRIPTION_START, payload);

export const deleteWebhookSubscriptionSuccess = () =>
  action(WebhookActionTypes.DELETE_WEB_HOOK_SUBSCRIPTION_SUCCESS);

export const deleteWebhookSubscriptionFailure = (payload: string) =>
  action(WebhookActionTypes.DELETE_WEB_HOOK_SUBSCRIPTION_FAILURE, payload);

export const resetWebhookSubscriptions = () =>
  action(WebhookActionTypes.RESET_WEB_HOOK_SUBSCRIPTION);

export const getWebhookNotificationHistoryStart = (payload: Params) =>
  action(WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_HISTORY_START, payload);

export const getWebhookNotificationHistorySuccess = (payload: any) =>
  action(WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_HISTORY_SUCCESS, payload);

export const getWebhookNotificationHistoryFailure = (payload: string) =>
  action(WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_HISTORY_FAILURE, payload);

export const getWebhookNotificationDetailsStart = (payload: any) =>
  action(WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_DETAILS_START, payload);

export const getWebhookNotificationDetailsSuccess = (payload: any) =>
  action(WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_DETAILS_SUCCESS, payload);

export const getWebhookNotificationDetailsFailure = (payload: string) =>
  action(WebhookActionTypes.GET_WEB_HOOK_NOTIFICATION_DETAILS_FAILURE, payload);

export const redeliverWebhookNotificationStart = (payload: Params) =>
  action(WebhookActionTypes.REDELIVER_WEB_HOOK_NOTIFICATION_START, payload);

export const redeliverWebhookNotificationSuccess = (payload: any) =>
  action(WebhookActionTypes.REDELIVER_WEB_HOOK_NOTIFICATION_SUCCESS, payload);

export const redeliverWebhookNotificationFailure = (payload: string) =>
  action(WebhookActionTypes.REDELIVER_WEB_HOOK_NOTIFICATION_FAILURE, payload);

export const setNotificationHistoryFilter = (payload: any) =>
  action(WebhookActionTypes.SET_NOTIFICATION_HISTORY_SEARCH_FILTER, payload);

export const setNotificationHistoryOrderBy = (payload: any) =>
  action(WebhookActionTypes.SET_NOTIFICATION_HISTORY_SEARCH_ORDER_BY, payload);
